import { gql, useMutation } from '@apollo/client';
import {
  ProgramNlFlashMutation,
  ProgramNlFlashMutationVariables,
} from '../../../__generated__/queries-newsletter';

export const PROGRAM_NL_FLASH = gql`
  mutation ProgramNLFlash($data: FlashSenderProgramCreateInput!) {
    createFlashSenderProgram(data: $data) {
      id
      status
    }
  }
`;

export const useProgramNLFlash = () => {
  const [programNLFlash] = useMutation<
    ProgramNlFlashMutation,
    ProgramNlFlashMutationVariables
  >(PROGRAM_NL_FLASH);

  return programNLFlash;
};
